// React Dependencies
import { React, useEffect } from 'react';
// Common Dependencies
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// Components
import { Container, Form, Button } from 'react-bootstrap';
// Validation
import { useFormik } from 'formik';
import validationSchema from './FogetPasswordValidation';
// Alert
import { toast } from 'react-toastify';
// API Call
import { useForgotPassword } from '@hooks';
// Page Components
import { PublicLayout, LogoUrl } from '@adminlayout';
import { TNButton } from '@common/components';
// Font Awesome
import CommonSEOTitle from '../../../../helpers/CommonSEOTitle';
// React Icons
import { BiSolidEnvelope } from 'react-icons/bi';
// npm AOS animation
import AOS from 'aos';
import 'aos/dist/aos.css';

const ForgetPasswordPage = (props) => {
  // Props
  const { t, alert } = props;
  // Navigate
  const navigate = useNavigate();
  // On Load Add Class To The Body
  useEffect(() => {
    document.body.classList.add('bg-box');
    AOS.init({ duration: 3000 }); // npm AOS animation
  }, []);
  // Cancel Form
  const handleCancel = () => {
    if (formik.dirty && formik.dirty !== undefined) {
      alert({
        type: 'warning',
        title: 'Confirmation',
        message: t('page.reset_alert_popup_message'),
        confirmText: t('page.alert_popup_yes_button'),
        cancelText: t('page.alert_popup_no_button'),
        onConfirm: () => {
          navigate(`/login/`);
        }
      });
    } else {
      navigate(`/login/`);
    }
  };
  // Validate And Submit Request
  const { mutate: doForgotPassword, isLoading } = useForgotPassword(
    (response) => {
      toast.success(response.message);
      localStorage.forgot_token = response.data.user_id;
      localStorage.isAdmin = true;
      navigate('/otp-verification');
    },
    (error) => {
      window.scrollTo(0, 0);
      toast.error(error.message);
    }
  );
  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema,
    onSubmit: (values) => {
      doForgotPassword(values);
    }
  });
  return (
    <>
      <CommonSEOTitle title={t('page.forget_password_header_text')} />
      <PublicLayout>
        <div className="auth-pages">
          <div className="background-box" data-aos="fade-in">
            <div>
              <div className="brand-logo">
                <LogoUrl />
              </div>
              <div className="auth-heading">
                <h1 className="page-heading-center">{t('page.forget_password_header_text')}</h1>
                <div
                  className="auth-subheading"
                  dangerouslySetInnerHTML={{
                    __html: t('page.forget_password_sub_header_text')
                  }}></div>
              </div>

              <div>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group className="form-field-group fp-email-input-group">
                    <Form.Label className="field-label">
                      {t('page.forget_password_email_label')}
                    </Form.Label>
                    <Form.Control
                      className={
                        'form-field login-email ' +
                        (formik.touched.email && formik.errors.email
                          ? 'form-field-error'
                          : formik.touched.email && !formik.errors.email
                            ? 'form-field-success'
                            : '')
                      }
                      type="text"
                      name="email"
                      placeholder={t('page.forget_password_email_placeholder')}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />{' '}
                    <BiSolidEnvelope className="email-icon" />
                    <div className="form-field-error-text">
                      {formik.touched.email && formik.errors.email ? (
                        <div>{t(formik.errors.email)}</div>
                      ) : null}
                    </div>
                  </Form.Group>
                  <div className="primary-button">
                    <span className="cancel-button" onClick={handleCancel}>
                      {t('page.forget_password_login_link_text')}
                    </span>
                    <TNButton
                      loading={isLoading}
                      type="submit"
                      isdirtyform={formik.dirty && formik.dirty !== undefined ? 1 : 0}>
                      {t('page.forget_password_submit_button_text')}
                    </TNButton>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </PublicLayout>
    </>
  );
};
ForgetPasswordPage.propTypes = {
  t: PropTypes.func,
  isdirtyform: PropTypes.any
};
export { ForgetPasswordPage };
